import { useRef } from "react";
import { Upload } from "lucide-react";
import { useToastStore } from "../../../stores/toastStore";
import { useVisualizerStore } from "./store";
import type { OscalComponentDefinition } from "./types";

export function JSONUploader() {
  const inputRef = useRef<HTMLInputElement>(null);
  const loadJson = useVisualizerStore((s) => s.loadJson);

  const handleFile = (file: File) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const json = JSON.parse(e.target?.result as string) as OscalComponentDefinition;
        if (!json["component-definition"]) {
          useToastStore.getState().showError("Error", "Invalid OSCAL file: missing component-definition root");
          return;
        }
        loadJson(json, file.name);
        useToastStore.getState().showSuccess("Success", `Loaded ${file.name}`);
      } catch {
        useToastStore.getState().showError("Error", "Failed to parse JSON file");
      }
    };
    reader.readAsText(file);
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept=".json"
        className="hidden"
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) handleFile(file);
          e.target.value = "";
        }}
      />
      <button
        onClick={() => inputRef.current?.click()}
        className="flex items-center gap-2 px-4 py-2 rounded-lg bg-[#0f172a] text-white text-sm font-bold hover:bg-[#1e293b] transition-colors"
      >
        <Upload className="size-3.5" />
        Import JSON
      </button>
    </>
  );
}
